import React, { useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { usePrinter } from '../contexts/PrinterContext';
import { CFormLabel } from '@coreui/react';

function PrinterSelection({ value, onChange, className, labelClassName, multiSelect = true, required = false, error = false }) {
    const requiredIcon = required ? <span className="text-danger">*</span> : null;

    const { getAllPrinters } = usePrinter();

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    const fetchPrinters = async (searchValue, loadedOptions, { page }) => {
        try {
            const response = await getAllPrinters(page, rowsPerPage, 'id', -1, searchValue);

            if (response.totalPages > 0) {
                const newOptions = response.data.map((printer) => ({
                    label: printer.name,
                    value: printer.id,
                }));

                return {
                    options: newOptions,
                    hasMore: page !== response.totalPages,
                    additional: {
                        page: page + 1,
                    },
                };
            } else {
                return {
                    options: [],
                    hasMore: false,
                    additional: null,
                };
            }
        } catch (error) {
            console.error('Error fetching printers', error);
            return {
                options: [],
                hasMore: false,
                additional: null,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div className={className}>
            <div className={labelClassName}>
                <CFormLabel>Printer {requiredIcon}</CFormLabel>
            </div>
            <div className='w-100'>
                <AsyncPaginate
                    className={`${(error && required) && 'multiSelect_error'}`}
                    value={value}
                    loadOptions={fetchPrinters}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={onChange}
                    placeholder='Select printers...'
                    noOptionsMessage={() => ('No printers found')}
                    loadingMessage={() => ('Printers Loading...')}
                    additional={{
                        page: currentPage,
                    }}
                    SelectProps={{
                        isSearchable: true
                    }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector('body')}
                    styles={customStyles}
                />
                {(error && required) && <span className="text-danger error_message">Please select any one printer.</span>}
            </div>
        </div>
    );
}

export default PrinterSelection